import { Component, OnInit } from '@angular/core';
import { WarrantiesService } from '../service/warranties.service';
import { Observable } from 'rxjs';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { IssueWarrantyDTO, IssueWarrantyQueryParams } from './interfaces/warranty.interface';
import { WarrantyFilterViewModel } from './interfaces/warranty-viewmodel.interface';

@Component({
  selector: 'app-warranties',
  templateUrl: './warranties.component.html',
  styleUrls: ['./warranties.component.scss']
})
export class WarrantiesComponent implements OnInit {

  public pagedWarranties$: Observable<PageResult<IssueWarrantyDTO>>;
  public warrantyParams: IssueWarrantyQueryParams = {
    page: 1,
    pageSize: 5,
    start: null,
    end: null,
    sortColumn: 'EmissionDate',
    sortDirection: 'desc'
  };

  constructor(private warrantiesService: WarrantiesService){
    const today = new Date();
    this.warrantyParams = {
      ...this.warrantyParams,
      start: today,
      end: today
    };
  }

  ngOnInit(): void {
    this.getIssueWarranties();
  }

  public getIssueWarranties(): void {
    this.pagedWarranties$ = this.warrantiesService.getIssueWarranties(this.warrantyParams);
  }

  public receiveUpdatedFilters(warrantyFilterVm: WarrantyFilterViewModel) {
    this.warrantyParams = {
      ...this.warrantyParams,
      start: warrantyFilterVm.start,
      end: warrantyFilterVm.end,
      search: warrantyFilterVm.search
    };
    this.getIssueWarranties();
  }

  public receiveChangePagination(pagination: any) {
    this.warrantyParams = {
      ...this.warrantyParams,
      page: pagination.page,
      pageSize: pagination.pageSize
    };
    this.getIssueWarranties();
  }

  public receiveSorting(sorting: any) {
    this.warrantyParams = {
      ...this.warrantyParams,
      sortColumn: sorting?.sortColumn ?? '',
      sortDirection: sorting?.sortDirection ?? ''
    }
    this.getIssueWarranties();
  }

}